import { render, staticRenderFns } from "./LoyaltyMemberForm.vue?vue&type=template&id=71281788&"
import script from "./LoyaltyMemberForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyMemberForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports